module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.31017",
      "ably": "static-2.2",
      "ably-hubspot-js": "static-2.5129",
      "atom": "static-1.5499",
      "client-types": "static-1.506",
      "conversations-error-reporting": "static-1.9247",
      "conversations-internal-pub-sub": "static-1.16417",
      "conversations-internal-schema": "static-1.13557",
      "conversations-message-history": "static-1.13658",
      "conversations-test-sdk": "static-1.10858",
      "conversations-visitor-experience-components": "static-1.24380",
      "data-fetching-client": "static-1.10069",
      "head-dlb": "static-1.5007",
      "hs-promise-utils": "static-1.6011",
      "hs-test-utils": "static-1.8460",
      "hubspot-dlb": "static-2.1911",
      "HubStyleTokens": "static-2.11914",
      "I18n": "static-7.1695",
      "immer": "static-1.104",
      "jasmine-immutable": "static-1.3371",
      "jasmine-runner": "static-1.6872",
      "quartz": "static-1.7596",
      "react-dlb": "static-1.92",
      "react-select-plus": "static-1.117",
      "react-transition-group": "static-2.77",
      "redux-thunk": "static-2.83",
      "reselect": "static-3.15",
      "sanitize": "static-1.4895",
      "StyleGuideUI": "static-3.514",
      "transmute": "static-2.97",
      "urlinator": "static-1.4938",
      "usage-tracker": "static-1.7736",
      "usage-tracker-core": "static-1.7586",
      "usage-tracker-public": "static-1.7547",
      "viral-links-lib": "static-1.7501",
      "visitor-ui-component-library": "static-1.6579",
      "webpack-env": "static-1.54",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.5233",
      "conversations-visitor-message-history": "static-1.23117",
      "cssUtils": "static-1.1044",
      "enviro": "static-4.455",
      "flux-actions": "static-1.380",
      "foundations-components": "static-1.8668",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.6631",
      "interactive-cards": "static-1.499",
      "hubspot-url-utils": "static-1.4383",
      "immutable": "static-2.88",
      "metrics-js": "static-1.9990",
      "PatternValidationJS": "static-1.3308",
      "PortalIdParser": "static-2.404",
      "pulse": "static-1.1063",
      "raven": "static-3.5925",
      "react": "static-7.202",
      "react-aria": "static-1.76",
      "react-dom": "static-7.85",
      "react-redux": "static-7.80",
      "react-rhumb": "static-1.17155",
      "react-utils": "static-2.5629",
      "redux": "static-4.81",
      "rpc-client-utils": "static-1.5091",
      "redux-toolkit": "static-1.81",
      "sanitize-text": "static-1.8578",
      "signup-constants": "static-1.19852",
      "styled-components": "static-2.100",
      "usage-tracker-multi": "static-1.6150",
      "visitor-ui-component-library-icons": "static-1.6390",
      "hs-promise-rejection-tracking": "static-1.5587",
      "raven-hubspot": "static-1.6232",
      "hoist-non-react-statics": "static-3.9",
      "moment": "static-3.75",
      "quartz-config": "static-1.1374",
      "quartz-core": "static-1.6815",
      "foundations-assets": "static-1.5307",
      "foundations-theming": "static-1.4904",
      "UIComponents": "static-3.8860",
      "conversations-async-data": "static-2.8082",
      "customer-data-email": "static-1.18589",
      "cv-backend-services": "static-1.1607",
      "immutable-less": "static-1.5072",
      "conversations-skeleton-state": "static-1.7602",
      "crm-events-viz-core": "static-1.34337",
      "customer-data-objects": "static-1.8115",
      "icons": "static-2.699",
      "react-input-autosize": "static-2.17",
      "react-performance-metrics-lib": "static-1.972",
      "ui-images": "static-2.1269",
      "apollo-stack-hubspot": "static-3.98",
      "fast-json-stable-stringify": "static-1.4",
      "graphql": "static-1.92",
      "HeadJS": "static-2.814",
      "framer-motion": "static-1.83",
      "hs-test-utils-bend-plugin": "static-1.3571",
      "msw": "static-1.102",
      "msw-config": "static-1.22",
      "testing-library": "static-1.163",
      "i18n-data": "static-1.233",
      "moment-timezone": "static-5.94",
      "jasmine": "static-4.4730",
      "signup-ui-url-generator": "static-2.8481",
      "quartz-i18n": "static-1.1271",
      "sassPrefix": "static-1.310",
      "bend-plugin-foundations-components": "static-1.4937",
      "floating-ui": "static-1.67",
      "foundations-theming-specialty": "static-1.2620",
      "hs-story-utils": "static-1.9847",
      "react-create-root-preference": "static-1.93",
      "react-virtualized": "static-2.111",
      "tanstack-table": "static-1.65",
      "trellis-assets": "static-1.2965",
      "ui-fonts": "static-1.1176",
      "hs-locale-management": "static-1.367",
      "dompurify": "static-1.11",
      "utility-belt": "static-1.2957",
      "bend-plugin-pulse": "static-1.566",
      "batch-promise": "static-1.1968",
      "chirp-fetch": "static-1.2323",
      "event-emitter": "static-1.1381",
      "fast-json-patch": "static-1.73",
      "hub-http-janus": "static-1.899",
      "quick-fetch": "static-1.4197",
      "csstype": "static-1.50",
      "quartz-head": "static-1.1261",
      "web-vitals": "static-1.18",
      "bend-plugin-chirp-manifest": "static-1.501",
      "quartz-routing": "static-1.1026",
      "usage-tracker-anonymous": "static-1.6153",
      "opentelemetry-fe-types": "static-1.209",
      "dispatcher": "static-1.146",
      "general-store": "static-6.20",
      "hubspotter-http": "static-1.4934",
      "mobile-manifest-mixins": "static-1.597",
      "module-federation": "static-1.37",
      "opentelemetry-fe": "static-1.584",
      "quartz-auth": "static-1.1271",
      "quartz-test": "static-1.1271",
      "quartz-tracking": "static-1.975",
      "trellis-components": "static-1.2984",
      "usage-tracker-container": "static-1.7726",
      "bend-plugin-foundations-theming": "static-1.3387",
      "foundations-theming-base": "static-1.3889",
      "stylex": "static-1.45",
      "HubStyle": "static-2.12221",
      "react-immutable-proptypes": "static-2.8",
      "apollo-dlb": "static-3.98",
      "apollo-link-hub-http": "static-2.5022",
      "customer-data-ui-utilities": "static-1.10255",
      "FileManagerCore": "static-1.40253",
      "FileManagerLib": "static-1.40394",
      "hubspot-apollo-client": "static-1.5299",
      "react-immutable-render-mixin": "static-1.9",
      "salesImages": "static-1.679",
      "timezone-utils": "static-2.5653",
      "ui-gdpr-components": "static-1.10651",
      "ts-schema": "static-1.4367",
      "ai-components-ui-library": "static-1.9935",
      "avatar-components": "static-1.2906",
      "content-assistance-lib": "static-1.8350",
      "crm-component-utils": "static-1.40072",
      "crm-display-components": "static-1.25822",
      "crm-fe-perf": "static-1.23318",
      "crm-links": "static-1.6727",
      "crm-message-bus": "static-1.43999",
      "crm-search-service-types": "static-1.1559",
      "crm-source-interpretation-lib": "static-1.5750",
      "customer-data-communicator": "static-1.46538",
      "customer-data-filters-ui": "static-1.41239",
      "customer-data-objects-ui-components": "static-1.13452",
      "customer-data-properties": "static-1.52900",
      "customer-data-rte": "static-1.33819",
      "draft-plugins": "static-2.22281",
      "file-manager-components": "static-1.24754",
      "trellis-theming": "static-1.1407",
      "framework-data-schema-resolvers": "static-1.7314",
      "frontend-preferences-client": "static-1.8340",
      "hubspot-prosemirror": "static-1.19189",
      "object-comments-thread-lib": "static-1.11539",
      "prosemirror-user-and-team-at-mentions": "static-1.1388",
      "reference-resolvers-lite": "static-1.8528",
      "ui-addon-upgrades": "static-9.18513",
      "universal-associations-select": "static-1.11505",
      "universal-record-utils-lib": "static-1.2252",
      "wootric-nps": "static-1.7268",
      "inbound-db-properties-service-client": "static-1.4114",
      "property-translator": "static-1.5801",
      "segments-query-core": "static-1.1851",
      "bender-build-tools": "static-1.3518",
      "stylex-utils": "static-1.163",
      "opentelemetry-web": "static-1.20",
      "beacon-keepalive-queue": "static-1.122",
      "hub-http-shared-msw-handlers": "static-1.10818",
      "hubspotter-http-shared-msw-handlers": "static-1.10816",
      "usage-tracker-session-replay": "static-1.5422",
      "base-ui": "static-1.26",
      "react-day-picker": "static-1.14",
      "tanstack-virtual": "static-1.42",
      "react-dnd-compat": "static-1.5032",
      "breeze-artifacts-sdk": "static-1.706",
      "copilot-toolkit": "static-1.12057",
      "audio-components": "static-1.6498",
      "ContentUtils": "static-1.69354",
      "cropperjs": "static-1.10",
      "feedback-loader": "static-1.29985",
      "FileManagerImages": "static-1.37905",
      "foundations-components-legacy": "static-1.1693",
      "html-to-image": "static-1.64",
      "immerable": "static-1.4563",
      "react-colorpicker": "static-2.10635",
      "ui-universal-auth": "static-1.9633",
      "video-components": "static-1.14344",
      "video-data-lib": "static-1.36000",
      "video-embed": "static-1.36834",
      "hubspot-apollo-cache": "static-1.758",
      "chatspot-core": "static-1.23548",
      "superstore": "static-1.5180",
      "ui-addon-video-player": "static-1.9057",
      "ui-coaching-tips": "static-1.29517",
      "card-properties-lib": "static-1.45231",
      "commerce-subscription-lib": "static-1.38003",
      "crm-actions": "static-1.6772",
      "crm-cards-sdk": "static-1.44885",
      "customer-data-properties-shared-msw-handlers": "static-1.10145",
      "customer-data-property-utils": "static-1.8467",
      "customer-data-tracking": "static-1.7294",
      "hs-resources": "static-1.619",
      "inbound-db-meta-service-client": "static-1.3745",
      "framework-data-table": "static-2.12759",
      "location-customization-utils-lib": "static-1.10330",
      "restore-request-side-panel-lib": "static-1.1929",
      "calling-error-reporting": "static-1.31753",
      "calling-internal-common": "static-1.31746",
      "calling-usage-tracker": "static-1.6956",
      "crm_data": "static-4.93093",
      "customer-data-content": "static-1.27958",
      "draft-content-plugins": "static-1.29077",
      "draft-convert": "static-2.83",
      "draft-extend": "static-3.87",
      "draft-js": "static-5.89",
      "draft-signature-plugin": "static-1.24803",
      "EmailSignatureEditor": "static-1.25168",
      "hubspot-prosemirror-plugins": "static-1.19181",
      "integration-settings-components": "static-1.16408",
      "integrations-lib": "static-1.17314",
      "integrations-tracking-lib": "static-1.6033",
      "laboratory-lib": "static-3.7572",
      "native-integrations-shared-strings": "static-1.8184",
      "nav-meta": "static-1.30709",
      "onboarding-scopes": "static-1.6874",
      "prosemirror": "static-1.13",
      "prosemirror-copilot": "static-1.12520",
      "quotes-client-types": "static-1.39092",
      "reference-resolvers": "static-1.8599",
      "rich-text-lib": "static-1.20479",
      "sales-email-signature-service-client": "static-1.4272",
      "sequences-lib": "static-1.8694",
      "ui-addon-i18n": "static-1.11568",
      "ui-addon-iframeable": "static-1.9499",
      "ui-business-units-lib": "static-1.9517",
      "ui-shepherd-react": "static-3.10696",
      "user-context": "static-1.5480",
      "whatsapp-sending-lib": "static-1.7072",
      "customer-data-filters-ui-msw-helpers": "static-1.23674",
      "customer-data-reference-ui-components": "static-1.13589",
      "events-data-lib": "static-1.669",
      "FormUrlGenerator": "static-2.5136",
      "framework-builder-read-service-client": "static-1.4294",
      "multi-account-reference-resolvers": "static-1.1425",
      "onboarding-tours": "static-1.17313",
      "reporting-datasets-permissions-lib": "static-1.14681",
      "segments-client-types": "static-1.11987",
      "SharedI18nStrings": "static-1.186",
      "ui-addon-teams": "static-1.21969",
      "calling-global-api": "static-1.66037",
      "calling-lifecycle-internal": "static-1.67419",
      "calling-lifecycle-messages": "static-1.59712",
      "commerce-products-lib": "static-1.10777",
      "conditional-properties-service-client": "static-1.4087",
      "crm-index-visualization-core": "static-1.4687",
      "crm-pipelines-api-client-types": "static-1.4418",
      "external-options-client-types": "static-1.4416",
      "formula-editor": "static-1.14942",
      "google-libphonenumber": "static-1.48",
      "inbounddb-objects-service-types": "static-1.4497",
      "meetings-icalendar-utils-lib": "static-1.1059",
      "multi-currency-client-types": "static-1.3983",
      "object-builder-ui-client": "static-1.49939",
      "pipeline-validation-client-types": "static-1.4255",
      "property-value-citations": "static-1.3514",
      "smart-data-capture-core": "static-1.367",
      "smart-property-lib": "static-1.8535",
      "tiered-pricing": "static-1.2154",
      "topics-actions-lib": "static-1.597",
      "trial-components-library": "static-1.14298",
      "ui-addon-form-validation": "static-1.11341",
      "zustand": "static-1.88",
      "breeze-engine-lib": "static-1.2020",
      "poll-commands": "static-1.3896",
      "video-components-external": "static-1.12342",
      "fdsr-migration-layer": "static-1.433",
      "framework-data-schema-quick-fetch": "static-1.7219",
      "persist-promise": "static-1.4125",
      "content-media-capture": "static-1.5690",
      "emoji-mart": "static-3.6",
      "growth-payments-core": "static-1.26409",
      "knowledge-content-types": "static-1.8706",
      "payment-link-components": "static-1.24354",
      "ui-addon-emoji-picker": "static-1.10288",
      "call-summary": "static-1.40726",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.10964",
      "merchandise-lib": "static-1.283",
      "purchase-motions-components": "static-1.6569",
      "crm-object-search-query-utilities": "static-1.10384",
      "amplitude-session-replay-browser": "static-1.60",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "magpie-lib": "static-1.5858",
      "magpie-types": "static-1.5318",
      "simple-logging-lib": "static-1.3473",
      "cms-field-types": "static-1.5234",
      "content-icons-ui": "static-1.2418",
      "underscore": "static-1.8",
      "nudge-client-utils": "static-1.3331",
      "unified-auth-core-lib": "static-1.1429",
      "social-insights-client-types": "static-1.22849",
      "outpost": "static-1.4555",
      "markdown-it": "static-1.6",
      "growth-onboarding-feedback-components": "static-1.7004",
      "customer-data-sidebar": "static-2.46935",
      "enrichment-lib": "static-1.801",
      "ui-addon-draggable-compat": "static-2.4683",
      "commerce-billing-lib": "static-1.20444",
      "commerce-shared-components-lib": "static-1.19487",
      "commerce-tools-ui-lib": "static-1.11240",
      "customer-data-associations": "static-1.7753",
      "tasks-actions-lib": "static-1.343",
      "reporting-data": "static-1.69205",
      "ui-addon-draggable": "static-3.5169",
      "crm-record-cards-service-types": "static-1.3836",
      "crm_universal": "static-1.22649",
      "SalesContentIndexUI": "static-3.9692",
      "content-embed-lib": "static-1.7761",
      "data-model-builder-lib": "static-1.13406",
      "remote-dom": "static-1.8",
      "remote-ui": "static-1.75",
      "ui-components-test-utils": "static-1.6051",
      "ui-extensions-remote-renderer": "static-1.18119",
      "universal-page-editor-lib": "static-1.3431",
      "integrations-error-boundary-lib": "static-1.14729",
      "redux-observable": "static-1.78",
      "ReduxMessenger": "static-2.10793",
      "rxjs": "static-5.10",
      "unified-auth": "static-1.1147",
      "ai-addon-copilot-preview": "static-1.9147",
      "data-token-picker": "static-1.17051",
      "sequences-client-types-lib": "static-1.8551",
      "foundations-components-test-utils": "static-1.6151",
      "navigation-messaging": "static-1.8399",
      "getting-started-shared-tasks": "static-1.19475",
      "getting-started-shared-tasks-store": "static-1.18593",
      "onboarding-tours-utils": "static-1.1380",
      "messaging-usage-based-billing-components-lib": "static-1.2235",
      "marketing-platform-lib": "static-1.7314",
      "whatsapp-management-lib": "static-1.10231",
      "growth-data-modal": "static-1.6059",
      "growth-onboarding-confetti": "static-1.3485",
      "growth-onboarding-next-action-utils": "static-1.2899",
      "navigation-components": "static-1.19072",
      "onboarding-tours-client": "static-1.5528",
      "ui-shepherd-tracker": "static-1.8077",
      "crm-index-associations-lib": "static-1.6870",
      "shared-worker-versioning": "static-1.11462",
      "voice-sms-access-library": "static-1.2332",
      "commerce-permissions": "static-1.1201",
      "products-iframe-lib": "static-1.8815",
      "products-ui-components-shared-msw-handlers": "static-1.11200",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10901",
      "sales-views-client-types": "static-1.4680",
      "bark-lib": "static-1.16953",
      "browser-prettier": "static-1.11",
      "codemirror": "static-5.105",
      "crm-properties-common-lib": "static-1.6310",
      "react-codemirror": "static-1.11062",
      "data-agent-kit": "static-1.819",
      "fsm": "static-1.4176",
      "policy-lib": "static-1.7228",
      "embedded-academy-lib": "static-1.15865",
      "hubs-service-types": "static-1.1687",
      "purchase-motions-api": "static-1.6572",
      "breeze-engine-chat-components": "static-1.998",
      "breeze-engine-core": "static-1.1298",
      "highlight.js": "static-1.89",
      "content-media-composition-data-lib": "static-1.13494",
      "content-media-compositions": "static-2.17501",
      "idb-keyval": "static-1.54",
      "media-bridge-lib": "static-1.19566",
      "fix-webm-duration": "static-1.33",
      "notification-sounds": "static-1.4848",
      "seat-types-lib": "static-1.953",
      "ui-addon-opt": "static-4.8806",
      "commerce-tours-lib": "static-1.6790",
      "growth-onboarding-reliability": "static-1.5504",
      "sales-checkout-service-client": "static-1.3951",
      "calling-cross-tab-library": "static-1.19725",
      "calling-lifecycle-usage-tracker": "static-1.9581",
      "reactive-lib": "static-1.1145",
      "nudge-custom-function-registry": "static-1.3088",
      "nudge-renderer-utils": "static-1.3407",
      "whisper-core-api": "static-1.7549",
      "card-payment-highlight-lib": "static-1.38209",
      "commerce-contract-lib": "static-1.13668",
      "invoices-highlight-card-lib": "static-1.56066",
      "orders-highlight-card-lib": "static-1.22415",
      "products-highlight-card-lib": "static-1.19060",
      "quotes-highlight-card-lib": "static-1.73002",
      "data-agent-test-utils": "static-1.363",
      "data-agent-utils": "static-1.832",
      "enrichment-settings-lib": "static-1.146",
      "usage-based-billing-components-lib": "static-1.10645",
      "payments-enrollment-embed-lib": "static-1.24110",
      "stripe-embedded-components": "static-1.8165",
      "growth-onboarding-empty-states": "static-1.6456",
      "InboxConnectUtils": "static-4.15758",
      "payments-post-enroll-local-storage-lib": "static-1.5525",
      "qrcode-generator": "static-1.79",
      "reporting-client-types": "static-1.2786",
      "react-flip-move": "static-1.82",
      "FireAlarmUi": "static-1.4808",
      "sales-templates-service-types-lib": "static-1.4458",
      "ui-asset-management-lib": "static-1.11523",
      "association-settings-lib": "static-1.11217",
      "collaboration-sidebar": "static-1.58956",
      "conditional-property-settings-components": "static-1.476",
      "conditional-property-settings-modal": "static-1.13387",
      "data-model-commons-lib": "static-1.13593",
      "ExportDialog": "static-6.10794",
      "final-form": "static-1.82",
      "property-management-iframe": "static-1.14365",
      "property-usages-lib": "static-1.5942",
      "reactflow": "static-1.75",
      "simple-data-table": "static-1.3742",
      "used-in-list-lib": "static-1.7394",
      "visual-association": "static-1.6319",
      "highcharts": "static-8.114",
      "reporting-visualizations": "static-1.61279",
      "ui-extensibility-client-types": "static-1.4338",
      "adobe-sign-auth-lib": "static-1.676",
      "ads-unified-auth-lib": "static-1.1778",
      "custom-vendor-connection-lib": "static-1.197",
      "google-sheets-integration-lib": "static-1.1243",
      "microsoft-drive-auth-lib": "static-1.403",
      "surveymonkey-integration-lib": "static-1.771",
      "slack-ui-library": "static-1.10819",
      "ai-rendering-library": "static-1.11318",
      "ai-settings-ui-library": "static-1.8503",
      "breeze-engine-ui-devtools": "static-1.394",
      "copilot-plugins": "static-1.12029",
      "messaging-shared-utils-lib": "static-1.1684",
      "messaging-user-info-utils-lib": "static-1.1854",
      "content-whatsapp-service-types": "static-1.646",
      "short-messages-app-service-client": "static-1.4347",
      "ui-tool-access": "static-1.10576",
      "onboarding-data-sync-lib": "static-1.2762",
      "growth-onboarding-next-action-components": "static-1.2927",
      "user-context-client": "static-1.4931",
      "nest": "static-1.657",
      "calling-orchestration-schema": "static-1.37109",
      "diff-match-patch": "static-1.7",
      "react-reducer-toolkit": "static-1.16580",
      "browser-eslint": "static-2.57",
      "trellis-story-utils": "static-1.4924",
      "storybook-react": "static-1.43",
      "academy-common-lib": "static-1.15325",
      "js-cookie": "static-1.18",
      "products-ui-components": "static-1.41295",
      "reporting-enablement": "static-1.24067",
      "settings-ui-lib": "static-1.12952",
      "accounting-integrations-ui-components": "static-1.7721",
      "invoices-ui-lib": "static-1.56082",
      "commerce-products-api": "static-1.2846",
      "invoices-iframe-lib": "static-1.58140",
      "quotes-modal-lib": "static-1.103680",
      "quotes-ui-lib": "static-1.81723",
      "fail-safe": "static-1.375",
      "one-click-checkout": "static-1.665",
      "platform-infra-nav-components": "static-1.7971",
      "reporting-ui-components": "static-2.66474",
      "subscription-experience-data-types": "static-1.15373",
      "marketplace-ui-apps-core": "static-1.19498",
      "stripe-connect-js": "static-1.81",
      "ui-addon-react-router-dom": "static-1.9951",
      "hub-http-contrib": "static-1.3450",
      "ui-addon-sales-email": "static-1.5624",
      "nested-table": "static-1.657",
      "chatspot-widget-iframe": "static-1.23539",
      "collaboration-sidebar-common": "static-1.3753",
      "conditional-property-settings-data": "static-1.494",
      "property-management-common": "static-1.6653",
      "d3": "static-1.7",
      "breeze-onboarding-components": "static-1.970",
      "data-integrations-breeze": "static-1.211",
      "global-styles-ai-lib": "static-1.405",
      "marketplace-embed-ba": "static-1.818",
      "mermaid": "static-1.44",
      "reporting-action-components": "static-1.42277",
      "reporting-snowflake": "static-1.57821",
      "upgrade-components-lib": "static-1.659",
      "ui-brand-identity-lib": "static-1.16809",
      "meetings-connect-utils-lib": "static-1.8038",
      "academy-service-client": "static-1.4115",
      "croppie": "static-2.10",
      "SafeStorage": "static-1.4815",
      "trellis-ecosystem": "static-1.7778",
      "commerce-tax-lib": "static-1.958",
      "price-books-api": "static-1.1941",
      "price-books-components": "static-1.1999",
      "property-description-translator": "static-1.4242",
      "ramp-editor": "static-1.1088",
      "data-quality-ui-library": "static-1.14186",
      "report-customization-components": "static-1.14120",
      "reporting-filters": "static-1.1211",
      "reporting-insights-lib": "static-1.2827",
      "reporting-plugins": "static-1.10910",
      "reporting-reports": "static-1.68881",
      "commerce-analytics-service-client": "static-1.3939",
      "totals-ui-components": "static-1.24485",
      "bend-plugin-fail-safe": "static-1.326",
      "checkout-sdk": "static-3.24603",
      "payment-method-components": "static-1.7267",
      "touchless-buying-components": "static-1.6471",
      "upgrade-catalog-service-types": "static-1.3847",
      "edison-service-client-types": "static-1.815",
      "developer-experience-shared-components": "static-1.10960",
      "marketplace-ui-client-types": "static-1.18373",
      "marketplace-ui-common": "static-1.20966",
      "ui-addon-integrations-directory-panel": "static-2.8389",
      "react-window": "static-1.13",
      "ts-utils-lib": "static-1.570",
      "onboarding-journeys-lib": "static-1.1151",
      "marketplace-embed": "static-1.23115",
      "marketplace-ui-install": "static-1.952",
      "marketplace-ui-tracking": "static-1.15136",
      "dashboard-lib": "static-1.83180",
      "share-with-third-party-component-lib": "static-1.9133",
      "ContentData": "static-1.69429",
      "line-items-api": "static-1.1257",
      "merge-modal-lib": "static-1.12942",
      "campaign-roi-lib": "static-1.10671",
      "campaigns-utils-lib": "static-1.3656",
      "ui-addon-calendars": "static-2.5785",
      "commerce-totals-service-types": "static-1.4106",
      "hub-http-rxjs": "static-1.868",
      "normalizr": "static-3.9",
      "ramda": "static-1.7",
      "billing-payments-client-types": "static-1.4412",
      "company-details-components": "static-1.6627",
      "emoji-regex": "static-1.7",
      "pricing-pages-ui-components": "static-1.16352",
      "quote-checkout-service-types": "static-1.3878",
      "apps-service-types": "static-1.4069",
      "oauth-service-types": "static-1.4597",
      "ui-product-approvals-common": "static-1.1447",
      "connections-embed-lib": "static-1.1671",
      "ai-studio-lib": "static-1.12658",
      "integrations-reconnect-lib": "static-1.644",
      "ui-product-approvals": "static-1.29552",
      "redux-actions": "static-3.73",
      "advanced-menus-core": "static-1.15739",
      "advanced-menus-lib": "static-1.12514",
      "ui-memberships-settings-lib": "static-1.35093",
      "tinymce-plugins": "static-1.58422",
      "copilot-messaging": "static-1.2307",
      "company-details-service-types": "static-1.4364",
      "pricing-pages-api": "static-1.16217",
      "trellis-ext-dnd": "static-1.466",
      "seamless-immutable": "static-7.6",
      "simple-menus-core": "static-1.15738",
      "simple-menus-lib": "static-1.17255",
      "interframe": "static-3.5162",
      "layout-dnd-components": "static-1.13142",
      "layout-dnd-utils": "static-1.12117",
      "tinymce": "static-5.11",
      "tinymce-data": "static-1.41393",
      "tinymce-themes": "static-1.57278",
      "dnd-kit": "static-1.20",
      "layout-data-lib": "static-1.10442",
      "NamespacedHubStyle": "static-2.9330"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.31017",
      "ably": "/ably/static-2.2",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.5129",
      "atom": "/atom/static-1.5499",
      "client-types": "/client-types/static-1.506",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.9247",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.16417",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.13557",
      "conversations-message-history": "/conversations-message-history/static-1.13658",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.10858",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.24380",
      "data-fetching-client": "/data-fetching-client/static-1.10069",
      "head-dlb": "/head-dlb/static-1.5007",
      "hs-promise-utils": "/hs-promise-utils/static-1.6011",
      "hs-test-utils": "/hs-test-utils/static-1.8460",
      "hubspot-dlb": "/hubspot-dlb/static-2.1911",
      "HubStyleTokens": "/HubStyleTokens/static-2.11914",
      "I18n": "/I18n/static-7.1695",
      "immer": "/immer/static-1.104",
      "jasmine-immutable": "/jasmine-immutable/static-1.3371",
      "jasmine-runner": "/jasmine-runner/static-1.6872",
      "quartz": "/quartz/static-1.7596",
      "react-dlb": "/react-dlb/static-1.92",
      "react-select-plus": "/react-select-plus/static-1.117",
      "react-transition-group": "/react-transition-group/static-2.77",
      "redux-thunk": "/redux-thunk/static-2.83",
      "reselect": "/reselect/static-3.15",
      "sanitize": "/sanitize/static-1.4895",
      "StyleGuideUI": "/StyleGuideUI/static-3.514",
      "transmute": "/transmute/static-2.97",
      "urlinator": "/urlinator/static-1.4938",
      "usage-tracker": "/usage-tracker/static-1.7736",
      "usage-tracker-core": "/usage-tracker-core/static-1.7586",
      "usage-tracker-public": "/usage-tracker-public/static-1.7547",
      "viral-links-lib": "/viral-links-lib/static-1.7501",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.6579",
      "webpack-env": "/webpack-env/static-1.54",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.5233",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.23117",
      "cssUtils": "/cssUtils/static-1.1044",
      "enviro": "/enviro/static-4.455",
      "flux-actions": "/flux-actions/static-1.380",
      "foundations-components": "/foundations-components/static-1.8668",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.6631",
      "interactive-cards": "/interactive-cards/static-1.499",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
      "immutable": "/immutable/static-2.88",
      "metrics-js": "/metrics-js/static-1.9990",
      "PatternValidationJS": "/PatternValidationJS/static-1.3308",
      "PortalIdParser": "/PortalIdParser/static-2.404",
      "pulse": "/pulse/static-1.1063",
      "raven": "/raven/static-3.5925",
      "react": "/react/static-7.202",
      "react-aria": "/react-aria/static-1.76",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.80",
      "react-rhumb": "/react-rhumb/static-1.17155",
      "react-utils": "/react-utils/static-2.5629",
      "redux": "/redux/static-4.81",
      "rpc-client-utils": "/rpc-client-utils/static-1.5091",
      "redux-toolkit": "/redux-toolkit/static-1.81",
      "sanitize-text": "/sanitize-text/static-1.8578",
      "signup-constants": "/signup-constants/static-1.19852",
      "styled-components": "/styled-components/static-2.100",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.6150",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.6390",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
      "raven-hubspot": "/raven-hubspot/static-1.6232",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "moment": "/moment/static-3.75",
      "quartz-config": "/quartz-config/static-1.1374",
      "quartz-core": "/quartz-core/static-1.6815",
      "foundations-assets": "/foundations-assets/static-1.5307",
      "foundations-theming": "/foundations-theming/static-1.4904",
      "UIComponents": "/UIComponents/static-3.8860",
      "conversations-async-data": "/conversations-async-data/static-2.8082",
      "customer-data-email": "/customer-data-email/static-1.18589",
      "cv-backend-services": "/cv-backend-services/static-1.1607",
      "immutable-less": "/immutable-less/static-1.5072",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7602",
      "crm-events-viz-core": "/crm-events-viz-core/static-1.34337",
      "customer-data-objects": "/customer-data-objects/static-1.8115",
      "icons": "/icons/static-2.699",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.972",
      "ui-images": "/ui-images/static-2.1269",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.98",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "graphql": "/graphql/static-1.92",
      "HeadJS": "/HeadJS/static-2.814",
      "framer-motion": "/framer-motion/static-1.83",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3571",
      "msw": "/msw/static-1.102",
      "msw-config": "/msw-config/static-1.22",
      "testing-library": "/testing-library/static-1.163",
      "i18n-data": "/i18n-data/static-1.233",
      "moment-timezone": "/moment-timezone/static-5.94",
      "jasmine": "/jasmine/static-4.4730",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8481",
      "quartz-i18n": "/quartz-i18n/static-1.1271",
      "sassPrefix": "/sassPrefix/static-1.310",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4937",
      "floating-ui": "/floating-ui/static-1.67",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2620",
      "hs-story-utils": "/hs-story-utils/static-1.9847",
      "react-create-root-preference": "/react-create-root-preference/static-1.93",
      "react-virtualized": "/react-virtualized/static-2.111",
      "tanstack-table": "/tanstack-table/static-1.65",
      "trellis-assets": "/trellis-assets/static-1.2965",
      "ui-fonts": "/ui-fonts/static-1.1176",
      "hs-locale-management": "/hs-locale-management/static-1.367",
      "dompurify": "/dompurify/static-1.11",
      "utility-belt": "/utility-belt/static-1.2957",
      "bend-plugin-pulse": "/bend-plugin-pulse/static-1.566",
      "batch-promise": "/batch-promise/static-1.1968",
      "chirp-fetch": "/chirp-fetch/static-1.2323",
      "event-emitter": "/event-emitter/static-1.1381",
      "fast-json-patch": "/fast-json-patch/static-1.73",
      "hub-http-janus": "/hub-http-janus/static-1.899",
      "quick-fetch": "/quick-fetch/static-1.4197",
      "csstype": "/csstype/static-1.50",
      "quartz-head": "/quartz-head/static-1.1261",
      "web-vitals": "/web-vitals/static-1.18",
      "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.501",
      "quartz-routing": "/quartz-routing/static-1.1026",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6153",
      "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.209",
      "dispatcher": "/dispatcher/static-1.146",
      "general-store": "/general-store/static-6.20",
      "hubspotter-http": "/hubspotter-http/static-1.4934",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.597",
      "module-federation": "/module-federation/static-1.37",
      "opentelemetry-fe": "/opentelemetry-fe/static-1.584",
      "quartz-auth": "/quartz-auth/static-1.1271",
      "quartz-test": "/quartz-test/static-1.1271",
      "quartz-tracking": "/quartz-tracking/static-1.975",
      "trellis-components": "/trellis-components/static-1.2984",
      "usage-tracker-container": "/usage-tracker-container/static-1.7726",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3387",
      "foundations-theming-base": "/foundations-theming-base/static-1.3889",
      "stylex": "/stylex/static-1.45",
      "HubStyle": "/HubStyle/static-2.12221",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "apollo-dlb": "/apollo-dlb/static-3.98",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5022",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10255",
      "FileManagerCore": "/FileManagerCore/static-1.40253",
      "FileManagerLib": "/FileManagerLib/static-1.40394",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5299",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "salesImages": "/salesImages/static-1.679",
      "timezone-utils": "/timezone-utils/static-2.5653",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10651",
      "ts-schema": "/ts-schema/static-1.4367",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.9935",
      "avatar-components": "/avatar-components/static-1.2906",
      "content-assistance-lib": "/content-assistance-lib/static-1.8350",
      "crm-component-utils": "/crm-component-utils/static-1.40072",
      "crm-display-components": "/crm-display-components/static-1.25822",
      "crm-fe-perf": "/crm-fe-perf/static-1.23318",
      "crm-links": "/crm-links/static-1.6727",
      "crm-message-bus": "/crm-message-bus/static-1.43999",
      "crm-search-service-types": "/crm-search-service-types/static-1.1559",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5750",
      "customer-data-communicator": "/customer-data-communicator/static-1.46538",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41239",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13452",
      "customer-data-properties": "/customer-data-properties/static-1.52900",
      "customer-data-rte": "/customer-data-rte/static-1.33819",
      "draft-plugins": "/draft-plugins/static-2.22281",
      "file-manager-components": "/file-manager-components/static-1.24754",
      "trellis-theming": "/trellis-theming/static-1.1407",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7314",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.8340",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19189",
      "object-comments-thread-lib": "/object-comments-thread-lib/static-1.11539",
      "prosemirror-user-and-team-at-mentions": "/prosemirror-user-and-team-at-mentions/static-1.1388",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8528",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18513",
      "universal-associations-select": "/universal-associations-select/static-1.11505",
      "universal-record-utils-lib": "/universal-record-utils-lib/static-1.2252",
      "wootric-nps": "/wootric-nps/static-1.7268",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4114",
      "property-translator": "/property-translator/static-1.5801",
      "segments-query-core": "/segments-query-core/static-1.1851",
      "bender-build-tools": "/bender-build-tools/static-1.3518",
      "stylex-utils": "/stylex-utils/static-1.163",
      "opentelemetry-web": "/opentelemetry-web/static-1.20",
      "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.122",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10818",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10816",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5422",
      "base-ui": "/base-ui/static-1.26",
      "react-day-picker": "/react-day-picker/static-1.14",
      "tanstack-virtual": "/tanstack-virtual/static-1.42",
      "react-dnd-compat": "/react-dnd-compat/static-1.5032",
      "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.706",
      "copilot-toolkit": "/copilot-toolkit/static-1.12057",
      "audio-components": "/audio-components/static-1.6498",
      "ContentUtils": "/ContentUtils/static-1.69354",
      "cropperjs": "/cropperjs/static-1.10",
      "feedback-loader": "/feedback-loader/static-1.29985",
      "FileManagerImages": "/FileManagerImages/static-1.37905",
      "foundations-components-legacy": "/foundations-components-legacy/static-1.1693",
      "html-to-image": "/html-to-image/static-1.64",
      "immerable": "/immerable/static-1.4563",
      "react-colorpicker": "/react-colorpicker/static-2.10635",
      "ui-universal-auth": "/ui-universal-auth/static-1.9633",
      "video-components": "/video-components/static-1.14344",
      "video-data-lib": "/video-data-lib/static-1.36000",
      "video-embed": "/video-embed/static-1.36834",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.758",
      "chatspot-core": "/chatspot-core/static-1.23548",
      "superstore": "/superstore/static-1.5180",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.9057",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.29517",
      "card-properties-lib": "/card-properties-lib/static-1.45231",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.38003",
      "crm-actions": "/crm-actions/static-1.6772",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.44885",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10145",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.8467",
      "customer-data-tracking": "/customer-data-tracking/static-1.7294",
      "hs-resources": "/hs-resources/static-1.619",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3745",
      "framework-data-table": "/framework-data-table/static-2.12759",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10330",
      "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1929",
      "calling-error-reporting": "/calling-error-reporting/static-1.31753",
      "calling-internal-common": "/calling-internal-common/static-1.31746",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.6956",
      "crm_data": "/crm_data/static-4.93093",
      "customer-data-content": "/customer-data-content/static-1.27958",
      "draft-content-plugins": "/draft-content-plugins/static-1.29077",
      "draft-convert": "/draft-convert/static-2.83",
      "draft-extend": "/draft-extend/static-3.87",
      "draft-js": "/draft-js/static-5.89",
      "draft-signature-plugin": "/draft-signature-plugin/static-1.24803",
      "EmailSignatureEditor": "/EmailSignatureEditor/static-1.25168",
      "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.19181",
      "integration-settings-components": "/integration-settings-components/static-1.16408",
      "integrations-lib": "/integrations-lib/static-1.17314",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6033",
      "laboratory-lib": "/laboratory-lib/static-3.7572",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8184",
      "nav-meta": "/nav-meta/static-1.30709",
      "onboarding-scopes": "/onboarding-scopes/static-1.6874",
      "prosemirror": "/prosemirror/static-1.13",
      "prosemirror-copilot": "/prosemirror-copilot/static-1.12520",
      "quotes-client-types": "/quotes-client-types/static-1.39092",
      "reference-resolvers": "/reference-resolvers/static-1.8599",
      "rich-text-lib": "/rich-text-lib/static-1.20479",
      "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4272",
      "sequences-lib": "/sequences-lib/static-1.8694",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.11568",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9499",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.9517",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.10696",
      "user-context": "/user-context/static-1.5480",
      "whatsapp-sending-lib": "/whatsapp-sending-lib/static-1.7072",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23674",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13589",
      "events-data-lib": "/events-data-lib/static-1.669",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.5136",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4294",
      "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1425",
      "onboarding-tours": "/onboarding-tours/static-1.17313",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14681",
      "segments-client-types": "/segments-client-types/static-1.11987",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.186",
      "ui-addon-teams": "/ui-addon-teams/static-1.21969",
      "calling-global-api": "/calling-global-api/static-1.66037",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67419",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59712",
      "commerce-products-lib": "/commerce-products-lib/static-1.10777",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4087",
      "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4687",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4418",
      "external-options-client-types": "/external-options-client-types/static-1.4416",
      "formula-editor": "/formula-editor/static-1.14942",
      "google-libphonenumber": "/google-libphonenumber/static-1.48",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4497",
      "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1059",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3983",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.49939",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4255",
      "property-value-citations": "/property-value-citations/static-1.3514",
      "smart-data-capture-core": "/smart-data-capture-core/static-1.367",
      "smart-property-lib": "/smart-property-lib/static-1.8535",
      "tiered-pricing": "/tiered-pricing/static-1.2154",
      "topics-actions-lib": "/topics-actions-lib/static-1.597",
      "trial-components-library": "/trial-components-library/static-1.14298",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11341",
      "zustand": "/zustand/static-1.88",
      "breeze-engine-lib": "/breeze-engine-lib/static-1.2020",
      "poll-commands": "/poll-commands/static-1.3896",
      "video-components-external": "/video-components-external/static-1.12342",
      "fdsr-migration-layer": "/fdsr-migration-layer/static-1.433",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7219",
      "persist-promise": "/persist-promise/static-1.4125",
      "content-media-capture": "/content-media-capture/static-1.5690",
      "emoji-mart": "/emoji-mart/static-3.6",
      "growth-payments-core": "/growth-payments-core/static-1.26409",
      "knowledge-content-types": "/knowledge-content-types/static-1.8706",
      "payment-link-components": "/payment-link-components/static-1.24354",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10288",
      "call-summary": "/call-summary/static-1.40726",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10964",
      "merchandise-lib": "/merchandise-lib/static-1.283",
      "purchase-motions-components": "/purchase-motions-components/static-1.6569",
      "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10384",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "magpie-lib": "/magpie-lib/static-1.5858",
      "magpie-types": "/magpie-types/static-1.5318",
      "simple-logging-lib": "/simple-logging-lib/static-1.3473",
      "cms-field-types": "/cms-field-types/static-1.5234",
      "content-icons-ui": "/content-icons-ui/static-1.2418",
      "underscore": "/underscore/static-1.8",
      "nudge-client-utils": "/nudge-client-utils/static-1.3331",
      "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1429",
      "social-insights-client-types": "/social-insights-client-types/static-1.22849",
      "outpost": "/outpost/static-1.4555",
      "markdown-it": "/markdown-it/static-1.6",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7004",
      "customer-data-sidebar": "/customer-data-sidebar/static-2.46935",
      "enrichment-lib": "/enrichment-lib/static-1.801",
      "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4683",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.20444",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19487",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11240",
      "customer-data-associations": "/customer-data-associations/static-1.7753",
      "tasks-actions-lib": "/tasks-actions-lib/static-1.343",
      "reporting-data": "/reporting-data/static-1.69205",
      "ui-addon-draggable": "/ui-addon-draggable/static-3.5169",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3836",
      "crm_universal": "/crm_universal/static-1.22649",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9692",
      "content-embed-lib": "/content-embed-lib/static-1.7761",
      "data-model-builder-lib": "/data-model-builder-lib/static-1.13406",
      "remote-dom": "/remote-dom/static-1.8",
      "remote-ui": "/remote-ui/static-1.75",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.6051",
      "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.18119",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3431",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14729",
      "redux-observable": "/redux-observable/static-1.78",
      "ReduxMessenger": "/ReduxMessenger/static-2.10793",
      "rxjs": "/rxjs/static-5.10",
      "unified-auth": "/unified-auth/static-1.1147",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.9147",
      "data-token-picker": "/data-token-picker/static-1.17051",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8551",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6151",
      "navigation-messaging": "/navigation-messaging/static-1.8399",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19475",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18593",
      "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1380",
      "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.2235",
      "marketing-platform-lib": "/marketing-platform-lib/static-1.7314",
      "whatsapp-management-lib": "/whatsapp-management-lib/static-1.10231",
      "growth-data-modal": "/growth-data-modal/static-1.6059",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3485",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2899",
      "navigation-components": "/navigation-components/static-1.19072",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.5528",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8077",
      "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6870",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.11462",
      "voice-sms-access-library": "/voice-sms-access-library/static-1.2332",
      "commerce-permissions": "/commerce-permissions/static-1.1201",
      "products-iframe-lib": "/products-iframe-lib/static-1.8815",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11200",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10901",
      "sales-views-client-types": "/sales-views-client-types/static-1.4680",
      "bark-lib": "/bark-lib/static-1.16953",
      "browser-prettier": "/browser-prettier/static-1.11",
      "codemirror": "/codemirror/static-5.105",
      "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6310",
      "react-codemirror": "/react-codemirror/static-1.11062",
      "data-agent-kit": "/data-agent-kit/static-1.819",
      "fsm": "/fsm/static-1.4176",
      "policy-lib": "/policy-lib/static-1.7228",
      "embedded-academy-lib": "/embedded-academy-lib/static-1.15865",
      "hubs-service-types": "/hubs-service-types/static-1.1687",
      "purchase-motions-api": "/purchase-motions-api/static-1.6572",
      "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.998",
      "breeze-engine-core": "/breeze-engine-core/static-1.1298",
      "highlight.js": "/highlight.js/static-1.89",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13494",
      "content-media-compositions": "/content-media-compositions/static-2.17501",
      "idb-keyval": "/idb-keyval/static-1.54",
      "media-bridge-lib": "/media-bridge-lib/static-1.19566",
      "fix-webm-duration": "/fix-webm-duration/static-1.33",
      "notification-sounds": "/notification-sounds/static-1.4848",
      "seat-types-lib": "/seat-types-lib/static-1.953",
      "ui-addon-opt": "/ui-addon-opt/static-4.8806",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.6790",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5504",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3951",
      "calling-cross-tab-library": "/calling-cross-tab-library/static-1.19725",
      "calling-lifecycle-usage-tracker": "/calling-lifecycle-usage-tracker/static-1.9581",
      "reactive-lib": "/reactive-lib/static-1.1145",
      "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3088",
      "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3407",
      "whisper-core-api": "/whisper-core-api/static-1.7549",
      "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.38209",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.13668",
      "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.56066",
      "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22415",
      "products-highlight-card-lib": "/products-highlight-card-lib/static-1.19060",
      "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.73002",
      "data-agent-test-utils": "/data-agent-test-utils/static-1.363",
      "data-agent-utils": "/data-agent-utils/static-1.832",
      "enrichment-settings-lib": "/enrichment-settings-lib/static-1.146",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10645",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.24110",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.8165",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6456",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.15758",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5525",
      "qrcode-generator": "/qrcode-generator/static-1.79",
      "reporting-client-types": "/reporting-client-types/static-1.2786",
      "react-flip-move": "/react-flip-move/static-1.82",
      "FireAlarmUi": "/FireAlarmUi/static-1.4808",
      "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4458",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11523",
      "association-settings-lib": "/association-settings-lib/static-1.11217",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.58956",
      "conditional-property-settings-components": "/conditional-property-settings-components/static-1.476",
      "conditional-property-settings-modal": "/conditional-property-settings-modal/static-1.13387",
      "data-model-commons-lib": "/data-model-commons-lib/static-1.13593",
      "ExportDialog": "/ExportDialog/static-6.10794",
      "final-form": "/final-form/static-1.82",
      "property-management-iframe": "/property-management-iframe/static-1.14365",
      "property-usages-lib": "/property-usages-lib/static-1.5942",
      "reactflow": "/reactflow/static-1.75",
      "simple-data-table": "/simple-data-table/static-1.3742",
      "used-in-list-lib": "/used-in-list-lib/static-1.7394",
      "visual-association": "/visual-association/static-1.6319",
      "highcharts": "/highcharts/static-8.114",
      "reporting-visualizations": "/reporting-visualizations/static-1.61279",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4338",
      "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.676",
      "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1778",
      "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.197",
      "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1243",
      "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.403",
      "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.771",
      "slack-ui-library": "/slack-ui-library/static-1.10819",
      "ai-rendering-library": "/ai-rendering-library/static-1.11318",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8503",
      "breeze-engine-ui-devtools": "/breeze-engine-ui-devtools/static-1.394",
      "copilot-plugins": "/copilot-plugins/static-1.12029",
      "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1684",
      "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1854",
      "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.646",
      "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4347",
      "ui-tool-access": "/ui-tool-access/static-1.10576",
      "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2762",
      "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2927",
      "user-context-client": "/user-context-client/static-1.4931",
      "nest": "/nest/static-1.657",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37109",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16580",
      "browser-eslint": "/browser-eslint/static-2.57",
      "trellis-story-utils": "/trellis-story-utils/static-1.4924",
      "storybook-react": "/storybook-react/static-1.43",
      "academy-common-lib": "/academy-common-lib/static-1.15325",
      "js-cookie": "/js-cookie/static-1.18",
      "products-ui-components": "/products-ui-components/static-1.41295",
      "reporting-enablement": "/reporting-enablement/static-1.24067",
      "settings-ui-lib": "/settings-ui-lib/static-1.12952",
      "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7721",
      "invoices-ui-lib": "/invoices-ui-lib/static-1.56082",
      "commerce-products-api": "/commerce-products-api/static-1.2846",
      "invoices-iframe-lib": "/invoices-iframe-lib/static-1.58140",
      "quotes-modal-lib": "/quotes-modal-lib/static-1.103680",
      "quotes-ui-lib": "/quotes-ui-lib/static-1.81723",
      "fail-safe": "/fail-safe/static-1.375",
      "one-click-checkout": "/one-click-checkout/static-1.665",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7971",
      "reporting-ui-components": "/reporting-ui-components/static-2.66474",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15373",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19498",
      "stripe-connect-js": "/stripe-connect-js/static-1.81",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9951",
      "hub-http-contrib": "/hub-http-contrib/static-1.3450",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5624",
      "nested-table": "/nested-table/static-1.657",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.23539",
      "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3753",
      "conditional-property-settings-data": "/conditional-property-settings-data/static-1.494",
      "property-management-common": "/property-management-common/static-1.6653",
      "d3": "/d3/static-1.7",
      "breeze-onboarding-components": "/breeze-onboarding-components/static-1.970",
      "data-integrations-breeze": "/data-integrations-breeze/static-1.211",
      "global-styles-ai-lib": "/global-styles-ai-lib/static-1.405",
      "marketplace-embed-ba": "/marketplace-embed-ba/static-1.818",
      "mermaid": "/mermaid/static-1.44",
      "reporting-action-components": "/reporting-action-components/static-1.42277",
      "reporting-snowflake": "/reporting-snowflake/static-1.57821",
      "upgrade-components-lib": "/upgrade-components-lib/static-1.659",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16809",
      "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8038",
      "academy-service-client": "/academy-service-client/static-1.4115",
      "croppie": "/croppie/static-2.10",
      "SafeStorage": "/SafeStorage/static-1.4815",
      "trellis-ecosystem": "/trellis-ecosystem/static-1.7778",
      "commerce-tax-lib": "/commerce-tax-lib/static-1.958",
      "price-books-api": "/price-books-api/static-1.1941",
      "price-books-components": "/price-books-components/static-1.1999",
      "property-description-translator": "/property-description-translator/static-1.4242",
      "ramp-editor": "/ramp-editor/static-1.1088",
      "data-quality-ui-library": "/data-quality-ui-library/static-1.14186",
      "report-customization-components": "/report-customization-components/static-1.14120",
      "reporting-filters": "/reporting-filters/static-1.1211",
      "reporting-insights-lib": "/reporting-insights-lib/static-1.2827",
      "reporting-plugins": "/reporting-plugins/static-1.10910",
      "reporting-reports": "/reporting-reports/static-1.68881",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3939",
      "totals-ui-components": "/totals-ui-components/static-1.24485",
      "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.326",
      "checkout-sdk": "/checkout-sdk/static-3.24603",
      "payment-method-components": "/payment-method-components/static-1.7267",
      "touchless-buying-components": "/touchless-buying-components/static-1.6471",
      "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3847",
      "edison-service-client-types": "/edison-service-client-types/static-1.815",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10960",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18373",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.20966",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8389",
      "react-window": "/react-window/static-1.13",
      "ts-utils-lib": "/ts-utils-lib/static-1.570",
      "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.1151",
      "marketplace-embed": "/marketplace-embed/static-1.23115",
      "marketplace-ui-install": "/marketplace-ui-install/static-1.952",
      "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.15136",
      "dashboard-lib": "/dashboard-lib/static-1.83180",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.9133",
      "ContentData": "/ContentData/static-1.69429",
      "line-items-api": "/line-items-api/static-1.1257",
      "merge-modal-lib": "/merge-modal-lib/static-1.12942",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.10671",
      "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3656",
      "ui-addon-calendars": "/ui-addon-calendars/static-2.5785",
      "commerce-totals-service-types": "/commerce-totals-service-types/static-1.4106",
      "hub-http-rxjs": "/hub-http-rxjs/static-1.868",
      "normalizr": "/normalizr/static-3.9",
      "ramda": "/ramda/static-1.7",
      "billing-payments-client-types": "/billing-payments-client-types/static-1.4412",
      "company-details-components": "/company-details-components/static-1.6627",
      "emoji-regex": "/emoji-regex/static-1.7",
      "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.16352",
      "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3878",
      "apps-service-types": "/apps-service-types/static-1.4069",
      "oauth-service-types": "/oauth-service-types/static-1.4597",
      "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1447",
      "connections-embed-lib": "/connections-embed-lib/static-1.1671",
      "ai-studio-lib": "/ai-studio-lib/static-1.12658",
      "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.644",
      "ui-product-approvals": "/ui-product-approvals/static-1.29552",
      "redux-actions": "/redux-actions/static-3.73",
      "advanced-menus-core": "/advanced-menus-core/static-1.15739",
      "advanced-menus-lib": "/advanced-menus-lib/static-1.12514",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35093",
      "tinymce-plugins": "/tinymce-plugins/static-1.58422",
      "copilot-messaging": "/copilot-messaging/static-1.2307",
      "company-details-service-types": "/company-details-service-types/static-1.4364",
      "pricing-pages-api": "/pricing-pages-api/static-1.16217",
      "trellis-ext-dnd": "/trellis-ext-dnd/static-1.466",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "simple-menus-core": "/simple-menus-core/static-1.15738",
      "simple-menus-lib": "/simple-menus-lib/static-1.17255",
      "interframe": "/interframe/static-3.5162",
      "layout-dnd-components": "/layout-dnd-components/static-1.13142",
      "layout-dnd-utils": "/layout-dnd-utils/static-1.12117",
      "tinymce": "/tinymce/static-5.11",
      "tinymce-data": "/tinymce-data/static-1.41393",
      "tinymce-themes": "/tinymce-themes/static-1.57278",
      "dnd-kit": "/dnd-kit/static-1.20",
      "layout-data-lib": "/layout-data-lib/static-1.10442",
      "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9330"
    },
    "bundlingPackage": "conversations-visitor-ui",
    "bundlingPackageVersion": "static-1.31017",
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};